(function () {
  if (window.nlStartYampiCheckout) return;

  var active = false;
  var attempt = 0;
  var controller = null;
  var changedButtons = [];
  var observer = null;
  var navigationTimer = null;
  var lastAdded = null;
  var addedSincePageShow = false;
  var timeout = 20000;

  document.addEventListener('click', function (event) {
    if (!active) return;
    var addButton = event.target.closest('.add-to-cart-ajax, #sticky-add-cart');
    if (addButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function buttonLoading(button) {
    if (!button || changedButtons.some(function (entry) { return entry.button === button; })) return;
    changedButtons.push({
      button: button,
      html: button.innerHTML,
      disabled: button.disabled,
      busy: button.getAttribute('aria-busy'),
      animation: button.style.animation
    });
    button.innerHTML = 'Finalizando a compra...';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.style.animation = 'none';
  }

  function restore() {
    active = false;
    window.nlCheckoutInProgress = false;
    clearTimeout(navigationTimer);
    navigationTimer = null;
    if (observer) observer.disconnect();
    observer = null;
    changedButtons.forEach(function (entry) {
      entry.button.innerHTML = entry.html;
      entry.button.disabled = entry.disabled;
      entry.button.style.animation = entry.animation;
      if (entry.busy === null) entry.button.removeAttribute('aria-busy');
      else entry.button.setAttribute('aria-busy', entry.busy);
    });
    changedButtons = [];
  }

  function watchCartButton() {
    var cart = document.getElementById('mini-cart');
    if (!cart || !window.MutationObserver) return;
    observer = new MutationObserver(function () {
      if (active) buttonLoading(cart.querySelector('[data-nl-yampi-checkout]'));
    });
    observer.observe(cart, { childList: true, subtree: true });
  }

  function withTimeout(promise) {
    var requestController = controller;
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () {
        if (requestController) requestController.abort();
        reject(new Error('A conexão demorou muito. Confira o carrinho e tente novamente.'));
      }, timeout);
      promise.then(function (value) {
        clearTimeout(timer);
        resolve(value);
      }, function (error) {
        clearTimeout(timer);
        reject(error);
      });
    });
  }

  function jsonRequest(url, options) {
    options = options || {};
    if (controller) options.signal = controller.signal;
    return withTimeout(fetch(url, options).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || (data && Number(data.status) >= 400)) {
          throw new Error(typeof data.description === 'string' ? data.description : 'Não foi possível continuar a compra. Confira o carrinho e tente novamente.');
        }
        return data;
      });
    }));
  }

  function getCart() {
    return jsonRequest(cartRoot() + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    });
  }

  function cartSignature(cart) {
    return JSON.stringify({ items: cart.items, attributes: cart.attributes, note: cart.note, token: cart.token });
  }

  function formSignature(formData) {
    var values = [];
    formData.forEach(function (value, key) {
      values.push([key, typeof value === 'string' ? value : value.name]);
    });
    return JSON.stringify(values);
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  window.nlStartYampiCheckout = function (button, formData) {
    if (active || !button || button.disabled) return;

    active = true;
    window.nlCheckoutInProgress = true;
    var myAttempt = ++attempt;
    controller = typeof AbortController === 'function' ? new AbortController() : null;
    buttonLoading(button);
    watchCartButton();

    var addedThisAttempt = false;
    var addWasAttempted = false;
    var signature = formData ? formSignature(formData) : null;
    var waitForCart = window.miniCart && window.miniCart.waitForUpdates
      ? window.miniCart.waitForUpdates()
      : Promise.resolve();

    withTimeout(waitForCart).then(function () {
      if (myAttempt !== attempt) return;
      if (!formData) return getCart();

      if (lastAdded && lastAdded.form === signature) {
        return getCart().then(function (cart) {
          if (lastAdded.cart === cartSignature(cart)) return cart;
          if (lastAdded.cart === null && cart.items && cart.items.some(function (item) {
            return String(item.variant_id) === String(formData.get('id'));
          })) return cart;
          return addProduct();
        });
      }
      return addProduct();
    }).then(function (cart) {
      if (myAttempt !== attempt) return;
      if (!cart || !cart.item_count) throw new Error('Seu carrinho está vazio. Adicione um produto antes de finalizar a compra.');
      if (addedThisAttempt && lastAdded) lastAdded.cart = cartSignature(cart);
      return jsonRequest('https://api.dooki.com.br/v2/public/shopify/cart', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ shop: window.location.host, cart_payload: cart })
      });
    }).then(function (response) {
      if (myAttempt !== attempt || !response) return;
      if (response.active === false || typeof response.checkout_direct_url !== 'string' || !response.checkout_direct_url.trim()) {
        throw new Error('Não foi possível abrir o checkout. Confira o carrinho e tente novamente.');
      }
      var url = new URL(response.checkout_direct_url, window.location.origin);
      if (url.protocol !== 'https:') throw new Error('Não foi possível abrir o checkout. Confira o carrinho e tente novamente.');
      window.location.assign(url.href);
      navigationTimer = setTimeout(function () {
        if (myAttempt !== attempt || !active) return;
        restore();
        if (addedThisAttempt) refreshCart();
        alert('Não foi possível abrir o checkout. Confira o carrinho e tente novamente.');
      }, timeout);
    }).catch(function (error) {
      if (myAttempt !== attempt) return;
      restore();
      if (addWasAttempted) refreshCart();
      var message = error && error.message;
      if (!message || error.name === 'TypeError' || error.name === 'AbortError') {
        message = 'Não foi possível finalizar a compra. Confira o carrinho antes de tentar novamente.';
      }
      alert(message);
    });

    function addProduct() {
      if (myAttempt !== attempt) return;
      addWasAttempted = true;
      return jsonRequest(cartRoot() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(function () {
        if (myAttempt !== attempt) return;
        addedThisAttempt = true;
        addedSincePageShow = true;
        lastAdded = { form: signature, cart: null };
        return getCart();
      });
    }
  };

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-nl-card-checkout]');
    if (!button) return;
    event.preventDefault();
    if (active || button.disabled) return;
    var variant = button.getAttribute('data-nl-card-checkout');
    if (!/^\d+$/.test(variant || '')) {
      alert('Não foi possível identificar o produto. Abra a página do produto e tente novamente.');
      return;
    }
    var formData = new FormData();
    formData.set('id', variant);
    formData.set('quantity', '1');
    window.nlStartYampiCheckout(button, formData);
  }, true);

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    attempt += 1;
    if (controller) controller.abort();
    restore();
    if (addedSincePageShow) {
      addedSincePageShow = false;
      refreshCart();
    }
  });

  window.addEventListener('pagehide', function () {
    clearTimeout(navigationTimer);
    navigationTimer = null;
  });
})();
